export enum Palettes {
    inverse = 'Theme_palette_inverse',
    static = 'Theme_palette_static',
}
